// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iajI","requiredAsterisk":"Info_requiredAsterisk__3N0AR"};